module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "otherfm"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('em', [_vm._v("The scent made him freeze in place")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('div', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He was held there by a scrap of a memory—one he’d thought forgotten years ago. A memory of exotic violet eyes fringed with thick, black lashes; of hair that slid through his greedy fingers like black silk; of creamy skin that held the sun’s fragrant kiss; and of a lush mouth, ripe for kisses that—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, William.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The voice possessed a throaty resonance that made even a whisper clear. It was rich, deeper than usual for a woman, and yet still feminine and richly wanton. William knew it as well as his own … and it was the last voice he expected to hear in his own cabin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aren’t you going to return my greeting? Or are we still not speaking?” The lilting voice ran up and down his spine, as sensual as a warm hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William gritted his teeth against his traitorous body before turning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There, sitting in a chair at the head of the captain’s table, was the one woman he’d never wished to see again.")]), _vm._v(" "), _c('p', {
    staticClass: "textright1"
  }, [_c('em', [_vm._v("Turn the page for rave reviews of"), _c('br'), _vm._v("Karen Hawkins’s romantic storytelling")]), _vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "otherfm"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("Praise for KAREN HAWKINS")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('div', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Always funny and sexy, a Karen Hawkins book is a sure delight!”")]), _vm._v(" "), _c('p', {
    staticClass: "textright1"
  }, [_vm._v("—Victoria Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Karen Hawkins writes fast, fun, and sexy stories that are a perfect read for a rainy day, a sunny day, or any day at all!”")]), _vm._v(" "), _c('p', {
    staticClass: "textright1"
  }, [_vm._v("—Christina Dodd")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Karen Hawkins will make you laugh and touch your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright1"
  }, [_vm._v("—Rachel Gibson")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_vm._v("and her sparkling historical romances")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("One Night in Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Enticing repartee … charming and witty.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Readers will be delighted by the perfect pacing, the humorous dialogue and the sizzling sensual romance.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_c('em', [_vm._v("—Romantic Times")]), _vm._v(" Top Pick")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("Much Ado About Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A delicious flirtation that pits a staid Englishman against a fey Scots woman. Humor, forklore, and sizzling love scenes lend this novel the perfect incentive for not wanting to put it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—"), _c('em', [_vm._v("Winter Haven News Chief")]), _vm._v(" (Florida)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Delightful banter.… Colorful secondary characters … add humor and charm.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("The Laird Who Loved Me")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Filled with biting reparté, humor, and sexual tension that will keep you turning the pages with glee.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")]), _vm._v(" (4½ stars, Top Pick)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("“Delightful in every way.”")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "textright"
  }, [_vm._v("—Reader To Reader")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("Sleepless in Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Amusing yet profound.… Readers will be sleepless in America due to a one-sitting enjoyable time.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—Harriet Klausner")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Made me laugh, cry and fall out of bed.… Karen is an author who will transport you back in time [and] have you placing her on your must-buy list!”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—Night Owl Reviews (Top Pick)")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("To Catch a Highlander")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Love and laughter, poignancy and emotional intensity, endearing characters, and a charming plot are the ingredients in Hawkins’s utterly delightful tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Fast, sensual, and brilliant.… This is romance at its best!”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—Romance and More")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("To Scotland, With Love")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Another winner … there were so many charming bits in it, I can’t even begin to describe them—but I found myself laughing a lot!”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—Rakehell Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "centerr"
  }, [_c('em', [_vm._v("How to Abduct a Highland Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Heated, exciting, and touching. Hawkins excels at taking tried-and-true plotlines and turning them into fresh, vibrant books.”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“"), _c('em', [_vm._v("How to Abduct a Highland Lord")]), _vm._v(" is laced with passion and drama, and with its wonderfully romantic and thrilling ending, it’s a story you don’t want to miss!”")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("—Joyfully Reviewed")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79752056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm.vue
// module id = 63
// module chunks = 0